<app-section-title [title]="contentService.content().mainPage.mySkillSet.title"
  (click)="triggerScroll('mySkills')"></app-section-title>


<div class="max-w-1500px">
   <app-mobile-section-title [text]="contentService.content().mainPage.mySkillSet.title"></app-mobile-section-title>
  <p class="pad-subtext-section-title-mobile">{{contentService.content().mainPage.mySkillSet.skillText}}</p>

  <div id="skills-container">
    @for (skill of contentService.content().mainPage.mySkillSet.skills; track skill.skillName) {
    <div class="skill-item">
      <img class="low-glow" [src]="skill.imgPath" [alt]="skill.skillName">
      <span>{{ skill.skillName }}</span>
    </div>
    }

    <div id="motivation-item-desktop">
      {{ contentService.content().mainPage.mySkillSet.motivationText }}
    </div>
  </div>
  <div id="motivation-item-mobile">
    {{ contentService.content().mainPage.mySkillSet.motivationText }}
  </div>
  <app-btn-to-contact [text]="contentService.content().mainPage.mySkillSet.contactBtn"></app-btn-to-contact>
</div>